// extracted by mini-css-extract-plugin
export var active = "_91-a";
export var activeIndicator = "_91-9";
export var disabled = "_91-b";
export var fullWidth = "_91-2";
export var lg = "_91-7";
export var md = "_91-6";
export var redoButtonTabGroup = "_91-0";
export var sm = "_91-5";
export var tabButton = "_91-4";
export var tabButtonsContainer = "_91-1";
export var themeDestructive = "_91-d";
export var themeNormal = "_91-c";
export var themeSuccess = "_91-e";
export var xl = "_91-8";
export var xs = "_91-3";